document.addEventListener('DOMContentLoaded', function() {
    const menuItems = document.querySelectorAll('.mobile-menu li.menu-item-has-children');

    menuItems.forEach(function(item) {
        // Create and append the dropdown toggle span
        const toggleSpan = document.createElement('span');
        toggleSpan.classList.add('dropdown-toggle');
        item.appendChild(toggleSpan);

        // Add click event to the span only
        toggleSpan.addEventListener('click', function(event) {
            const parent = this.parentElement;
            event.stopPropagation(); // Prevent bubbling up to other elements
            item.classList.toggle('active');

            // Remove active class from siblings
            const siblings = Array.from(parent.parentElement.children).filter(function(sibling) {
                return sibling !== parent;
            });

            siblings.forEach(function(sibling) {
                sibling.classList.remove('active');
            });
        });
    });
});
